import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useAddNewHubToPractice(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `mutation addNewHubToPractice($hubName: String) {
          addNewHub(newHubName: $hubName) {
            newHub {
              id
            }
          }
        }`;

    const resolver = ({ data: { addNewHub } }) => {
      return addNewHub;
    };

    return { query, resolver };
  }, []);

  const [mutation, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone,
  });

  const addNewHubToPractice = (hubName = "") => {
    return mutation(
      { hubName },
      {
        successMsg: "Successfully added a new hub.",
        defaultErrorMsg: "Failed to add a new hub.",
      }
    );
  };

  return { addNewHubToPractice: addNewHubToPractice, processing: loading };
}

export default useAddNewHubToPractice;
